import React, { Component } from "react";
import { Spin, Divider, Select, Space } from "antd";
import { ButtonItem } from "./Items";
import "./Styles.css";

function focusNextFromContainer(containerEl) {
  if (!containerEl) return;
  const allFocusable = Array.from(document.querySelectorAll(
    'input:not([disabled]):not(.ant-select-selection-search-input), ' +
    'button:not([disabled]), textarea:not([disabled]), ' +
    '.ant-select:not(.ant-select-disabled) .ant-select-selection-search-input, ' +
    '[tabindex]:not([tabindex="-1"])'
  ));
  const inside = allFocusable.filter(el => containerEl.contains(el));
  if (!inside.length) return;
  const idx = allFocusable.indexOf(inside[inside.length - 1]);
  const next = allFocusable[idx + 1];
  if (next) next.focus();
}

class SelectItem extends Component {
  selectRef = React.createRef();
  containerRef = React.createRef();

  // Texto que se muestra cuando está deshabilitado (copiable)
  getDisplayText() {
    const { value, mode, labelInValue, options, children } = this.props;

    // 1) labelInValue
    if (labelInValue) {
      if (Array.isArray(value)) return value.map(v => v?.label ?? v?.value ?? "").join(", ");
      return value?.label ?? value?.value ?? "";
    }

    // 2) options (si vienen)
    const opts = Array.isArray(options) && options.length ? options.flatMap((o) => (Array.isArray(o?.options) ? o.options : [o])) : null;
    const findLabelInOpts = (val) => {
      const hit = opts?.find(o => o.value === val);
      return hit?.label ?? val ?? "";
    };

    // 3) children <Select.Option> (fallback)
    const childList = [];
    if (!opts && children) {
      React.Children.forEach(children, (ch) => {
        if (ch && ch.props) childList.push({ value: ch.props.value, label: ch.props.children });
      });
    }
    const findLabelInChildren = (val) => {
      const hit = childList.find(o => o.value === val);
      return hit?.label ?? val ?? "";
    };

    // Multiple / Single
    if (mode === "multiple" || mode === "tags") {
      const vals = Array.isArray(value) ? value : [];
      return vals.map(v => (opts ? findLabelInOpts(v) : findLabelInChildren(v))).join(", ");
    }
    return (opts ? findLabelInOpts(value) : findLabelInChildren(value)) ?? "";
  }

  buildDropdownRender(menu) {
    const { selectAll, onSelectAll, mostrarCarga, loading, dropdownRender } = this.props;
    let content = menu;
    if (dropdownRender && typeof dropdownRender === "function") content = dropdownRender(menu);
    if (selectAll) {
      content = (
        <>
          {content}
          <Divider style={{ margin: "8px 0" }} />
          <Space style={{ padding: "0 8px 4px" }}>
            <ButtonItem type="text" onClick={onSelectAll}>Seleccionar Todos</ButtonItem>
          </Space>
        </>
      );
    }
    if (mostrarCarga) content = <Spin spinning={loading}>{content}</Spin>;
    return content;
  }

  render() {
    // Si está deshabilitado, muestra campo simple copiable y ya.
    if (this.props.disabled) {
      const text = this.getDisplayText();
      const combinedStyle = {
        ...(this.props.width ? { width: this.props.width } : {}),
        ...this.props.style
      };
      // Por defecto SÍ tiene fondo gris, a menos que noDisabledBackground sea true
      const baseClassName = this.props.noDisabledBackground ? "select-readonly select-readonly-no-bg" : "select-readonly";
      // Recorte a 2 líneas en solo-lectura: automático para campos de Insumo (placeholder "Insumo")
      // o cuando se pida explícito con la prop "recortar", sin tener que repetir la clase en cada pantalla.
      const aplicarRecorte = this.props.placeholder === "Insumo" || this.props.recortar;
      const clampClassName = aplicarRecorte ? "select-insumo-sin-word-break" : "";
      const tokens = `${baseClassName} ${this.props.className || ""} ${clampClassName}`.split(/\s+/).filter(Boolean);
      const className = Array.from(new Set(tokens)).join(" ");
      const contenido = text || this.props.placeholder || "";
      return (
        <div className={className} style={combinedStyle} title={typeof text === "string" ? text : undefined}>
          {aplicarRecorte
            ? <span className="select-readonly-clamp-inner">{contenido}</span>
            : contenido}
        </div>
      );
    }

    // ---- Select normal cuando NO está deshabilitado ----
    let propsNuevas = {};
    if (!this.props.noBuscar) {
      propsNuevas.filterOption = (input, option) =>
        option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0 ||
        option?.padre?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0;
      propsNuevas.showSearch = true;
    }
    propsNuevas.dropdownRender = (menu) => this.buildDropdownRender(menu);

    // Filtrar props que no quieres pasar
    let transformedProperties = {};
    for (const key in this.props) {
      if (!(key.toString() === "noBuscar" || key.toString() === "noFocusSiguiente")) {
        transformedProperties = { ...transformedProperties, [key]: this.props[key] };
      }
    }

    const style = {
      color: "inherit",
      backgroundColor: null,
      borderBottom: this.props.sinBorde ? "none" : "1px solid #E0FFFFFF",
      borderRadius: "4px",
      transition: "border-color 0.3s ease",
      boxShadow: this.props.sinBorde ? "none" : "0 1px 3px rgba(0,0,0,0.1)",
      width: this.props.width ? this.props.width : undefined,
      ...this.props.style,
    };

    return (
      <div ref={this.containerRef} style={{ display: 'contents' }}>
        <Select
          ref={this.selectRef}
          className="custom-disabled-select"
          dropdownMatchSelectWidth={this.props.placeholder === "Insumo" ? 600 : 400}
          {...propsNuevas}
          {...transformedProperties}
          placeholder={this.props.placeholder}
          style={style}
          bordered={false}
          onChange={(...args) => {
            this.props.onChange?.(...args);
            if (this.props.mode !== "multiple" && this.props.mode !== "tags") {
              this.selectRef.current?.blur();
              if (!this.props.noFocusSiguiente) {
                setTimeout(() => focusNextFromContainer(this.containerRef.current), 0);
              }
            }
          }}
        >
          {this.props.children}
        </Select>
      </div>
    );
  }
}

export default SelectItem;